import React from "react";
import { useFormContext } from "react-hook-form";

import "./mantra-button.css"

type InputProps = {
  text: string;
  type: "button" | "submit" | "reset";
  size?: "normal" | "large";
  isDisabled?: boolean;
  color?: "primary" | "secondary";
  tabIndex?: number;
  ariaLabel?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => Promise<void>;
};

export default function MantraButton({
  text,
  type,
  size = "normal",
  isDisabled = false,
  tabIndex,
  ariaLabel,
  color = "primary",
  onClick,
}: InputProps) {
  const form = useFormContext();

  const isSubmitting = form?.formState?.isSubmitting;
  const disabled = isDisabled || (type === "submit" && isSubmitting);

  return (
    <button
      disabled={disabled}
      aria-disabled={disabled}
      type={type}
      aria-label={ariaLabel || text}
      tabIndex={tabIndex}
      className={"w-94 h-24 rounded-lg shadow-2xl py-4 px-8 mantra-" + color + "-button"}
      onClick={onClick}
    >
      {!disabled ? (
        <div className={"mantra-" + color + "-button-text"}>{text}</div>
      ) : (
        <div className="mantra-button-text-disabled">{text}</div>
      )}
    </button>
  );
}